import axios from 'axios';
import type { TextKey } from '../i18n';
import { nowOperationalDateTimeString } from './operationalDateTime';

type T = (k: TextKey, v?: Record<string, string | number>) => string;

/**
 * Marca de agua de una exportación (antifraude): registra la exportación en el API y devuelve la línea que
 * va al inicio del archivo, con quién la sacó, cuándo y el número de registro. Si el registro falla (sin
 * conexión), la línea lleva solo la fecha y el archivo se descarga igual.
 */
export const exportWatermark = async (
  t: T,
  e: { fileName: string; rows: number; format?: 'csv' | 'xlsx' | 'pdf' },
): Promise<string> => {
  const screen = (window.location.hash || window.location.pathname || '').replace(/^#/, '').split('?')[0];
  try {
    const { data } = await axios.post('exports/log', { screen, fileName: e.fileName, rows: e.rows, format: e.format ?? 'csv' });
    const who = data?.user?.fullName ? `${data.user.fullName} (${data.user.username ?? data.user.id})` : String(data?.user?.username ?? data?.user?.id ?? '');
    return t('common.exportWatermark', { user: who, at: String(data?.at ?? nowOperationalDateTimeString()), id: Number(data?.id) || 0 });
  } catch {
    return t('common.exportWatermarkUnlogged', { at: nowOperationalDateTimeString() });
  }
};
